import { TBreakpointSize } from '@kurtosys/ksys-app-components/dist/models/TBreakpointSize';
import { Breakpoints } from './Breakpoints';

export function useBreakpointValue<TBreakpointValue>(breakpointValues: Record<TBreakpointSize, TBreakpointValue>): TBreakpointValue {
	return breakpointValues[Breakpoints.active];
}